import { Typography } from 'mobily-ui-library';
import { Suspense, useContext, useState, lazy } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import { useTranslation } from 'react-i18next';

import Loader from '../../components/Loader/Loader';

import Security from '../../assets/Security.svg';

import "./Login.scss";

const NumberLogin = lazy(() => import("../../components/NumberLogin/NumberLogin"));
const UsernameLogin = lazy(() => import("../../components/UsernameLogin/UsernameLogin"));
const OptionSelection = lazy(() => import("../../components/OptionSelection/OptionSelection"));

function Login() {
    const { t } = useTranslation();
    const { state }: any = useContext(GlobalContext);
    const { rtl, otpType, userType, bothType } = state;

    let type = otpType;
    if (otpType === '') type = userType;
    if (userType === '') type = otpType;
    if (bothType === 'both' || (otpType === '' && userType === '')) type = 'user';

    const [options, setOptions] = useState(type);

    const handleClick = (value: string) => {
        setOptions(value)
    }

    return (
        <Suspense fallback={<Loader />}>
            <div className={rtl ? "container EasyLogin__allThePage EL_right" : "container EasyLogin__allThePage"}>
                <div className='row'>
                    <div className="EL-text">
                        <img className="theIcon" src={Security} alt="icon" />
                        <Typography rtl={rtl} className="heading">{t("Welcome")}</Typography>
                        <Typography rtl={rtl} className="sub-heading">{t("Proceed_further")}</Typography>
                        <Typography rtl={rtl} className="sub-heading">{t("OtpCode_verify")}</Typography>
                    </div>

                    <OptionSelection
                        rtl={rtl}
                        options={options}
                        otpType={otpType}
                        userType={userType}
                        bothType={bothType}
                        handleClick={handleClick}
                    />
                    <div className="theLine"></div>
                    {options === 'otp' && (
                        <NumberLogin />
                    )}
                    {options === 'user' && (
                        <UsernameLogin />
                    )}
                </div>
            </div>
        </Suspense>
    )
}

export default Login